module.exports = __webpack_public_path__ + "img/img-card-how-work-3.54f7af29.svg";